import React, { memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
    loadingText: {
        marginTop: '16px',
        color: "#000",
        position: "absolute",
        top: "90px",
        width: "150px",
        left: "calc(50% - 75px)",
        textAlign: "center",
        [theme.breakpoints.up("sm")]: {
            width: "300px",
            left: "calc(50% - 150px)",
        },
        [theme.breakpoints.up("md")]: {
            width: "400px",
            left: "calc(50% - 200px)",
        },
        [theme.breakpoints.up("lg")]: {
            width: "600px",
            left: "calc(50% - 300px)",
        },
    },
}))

const Loading = memo((props) => {
    const classes = useStyles()
    const { content } = props
    const text = content || "Loading..."
    return (
        <Box className="loading-indicator-wrapper">
            <Box className="loading-indicator-container">
                <Box className="loading-indicator" />
                <Box className={classes.loadingText}>
                    <Typography>{text}</Typography>
                </Box>
            </Box>
        </Box>
    )
})

export default Loading
